export default "__VITE_ASSET__DzINhSmj__"